import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UiKitModule } from '@serviceplan/ui-kit';
import { HistoryComponent } from '../../history/history.component';

@Component({
  selector: 'thehubz-asset-history',
  templateUrl: './asset-history.component.html',
  styleUrls: ['./asset-history.component.scss'],
  standalone: true,
  imports: [CommonModule, UiKitModule, HistoryComponent],
})
export class AssetHistoryComponent implements OnInit {
  assetId = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    const currentPath = this.router.url.split('/');
    this.assetId = currentPath[currentPath.length - 2];
  }
}
